import React, { useEffect, useState } from "react";
import { Button } from "reactstrap";
import { responseToaster } from "../../../helperFunctions";
import DeleteModal from "../../../components/Custom/Modals/DeleteModal/DeleteModal";
import { useDispatch } from "react-redux";
import { useRole, useUser } from "../../../redux/slices/authSlice";
import { Table, TableRow } from "../../../components/Table";
import { payoutBlockInfoDelete } from "../../../redux/slices/payoutBlockInfoSlice";

const PayoutBlockInfoShowContent = (props) => {
  const { data, loading, onClose, onGet } = props;
  const [deleteId, setDeleteId] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [filterColumns, setFilterColumns] = useState([]);
  const { user } = useUser();
  const dispatch = useDispatch();
  const role = useRole("Payout Block Info");
  const columns = [
    {
      title: "Id",
      name: "merchantId",
    },
    {
      title: "Merchant Name",
      name: "merchantName",
    },
    {
      title: "Values",
      name: "values",
      Cell: (data) => {
        return (
          <div>
            {Object.entries?.(data?.values || {})?.map?.(([k, v], index) => (
              <div key={index}>
                <b>{k}:</b> {Array.isArray(v) ? v?.join?.(", ") : v}
              </div>
            ))}
          </div>
        );
      }
    },
    ...(role?.includes("payoutBlockInfo-delete") || user?.is_Admin ? [{
      title: "ACTION",
      name: "action",
      Cell: (data) => {
        return (
          <>
            <div className="d-flex flex-row gap-50">
              {role?.includes("payoutBlockInfo-delete") || user?.is_Admin ? <Button
                color="danger"
                className="btn-smallsize"
                onClick={() => {
                  const entries = Object.entries?.(data?.values || {});
                  const [key, value] = entries?.[0] || [];
                  setDeleteId({
                    key,
                    v: Array.isArray(value) ? value?.[0] : value,
                    k: data?.merchantId
                  });
                }}
              >
                <i className="fa-solid fa-trash"></i>
              </Button> : null}
            </div>
          </>
        );
      },
    }] : [])
  ];

  useEffect(() => {
    const newColumns = columns?.map((item) => item?.name);
    setFilterColumns(newColumns);
  }, []);

  const onHide = () => {
    onClose();
    setDeleteId({});
    setIsLoading(false);
    onGet?.();
  };
  const onDelete = async () => {
    try {
      setIsLoading(true);
      const payload = {
        merchantId: deleteId?.k,
        columnName: deleteId?.key,
        blockData: deleteId?.v,
      };
      const res = await dispatch(payoutBlockInfoDelete(payload)).unwrap();
      responseToaster(res);
      if (res?.status) {
        setDeleteId({});
        onHide()
      }
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Table
        columns={columns}
        isLoading={loading}
        data={data || []}
        isData={!!data?.length}
        filterColumns={filterColumns}
        count={data?.length || 0}
        isExpandable={false}
        onColumnsChange={(columns) => {
          setFilterColumns(columns);
        }}
      >
        {data?.map?.((item) => {
          return (
            <TableRow
              columns={columns}
              item={item}
              filterColumns={filterColumns}
              isExpandable={false}
            />
          );
        })}
      </Table>
      <DeleteModal
        title="Delete Payout Block Info"
        content="Are you sure you want to delete this payout block info ?"
        isOpen={Object?.keys?.(deleteId || {})?.length}
        onDoneClick={() => onDelete()}
        onCancelClick={() => setDeleteId({})}
        isButtonLoading={isLoading}
      />
    </>
  );
};

export default PayoutBlockInfoShowContent;
